'use strict';

import {Inject, Component, Input, EventEmitter, Output, Pipe, PipeTransform} from 'ng-metadata/core';
import {TabsAndScopesSelectorService} from './tabsAndScopesSelector.service';
//your imports go here
import {getSearchScopesMap, updateSearchScopesMap} from '../../../appConfig/appConfigForward';
import {ConfigurationUtil} from "../../../nddUtils/configurationUtil.service";
import {isBrowserEdge, isBrowserIE} from "../../../infra/browserSniffer";
import {preventStateReload} from '../../../infra/annotations';
import {STATE_NAMES} from "../../../primoExplore/primoExploreStates.module";

@Component({
    selector: 'prm-tabs-and-scopes-selector',
    templateUrl: 'components/search/searchBar/tabsAndScopesSelector/tabs-and-scopes-selector.html',
})

export class PrmTabsAndScopesSelector {
    private searchScopesMap: Object = getSearchScopesMap();
    private _tabOptions: Array<string>;
    private _scopeOptions: Array<string>;
    public scopesTranslated: Object = {};
    private isEdge = isBrowserEdge();

    private isOpen: boolean = false;
    @Input() selectedTab: string;
    @Input() selectedScope: string;
    @Output() private updateFindInDbEvent = new EventEmitter();
    @Output() private changeTabEvent = new EventEmitter();

    private KEY_CODE = {
        UP_ARROW: 38,
        DOWN_ARROW: 40,
        ENTER: 13,
    };

    constructor(private tabsAndScopesSelectorService: TabsAndScopesSelectorService,
                private configurationUtil: ConfigurationUtil,
                @Inject('$location') private $location: ng.ILocationService,
                @Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService,
                @Inject('$translate') private $translate,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                @Inject('$state') private $state: ng.ui.IStateService) {
        this.updateScopes();
        this._tabOptions = Object.keys(this.searchScopesMap);

    }

    ngAfterViewInit() {
        this.tab = this.tab || this._tabOptions[0];
        this._scopeOptions = this.searchScopesMap[this.tab];
        this.tabsAndScopesSelectorService.updateIsRemoteTab(this.tab);
    }

    get scope() {
        return this.selectedScope;
    }

    set scope(scope) {
        this.selectedScope = scope;
    }

    get tab() {
        return this.selectedTab;
    }

    set tab(tab) {
        this.selectedTab = tab;
    }


    get tabOptions() {
        return this._tabOptions;
    }

    get scopeOptions() {
        return this.searchScopesMap[this.tab];
    }

    get isRecentScopesEnabled() {
        return this.tabsAndScopesSelectorService.isRecentScopesEnabled;
    }

    get recentScopeOptions() {
        if (this.tabsAndScopesSelectorService.recentScopesByTabMap) {
            return this.tabsAndScopesSelectorService.recentScopesByTabMap[this.tab];
        }
        return this.tabsAndScopesSelectorService.recentScopesByTabMap;
    }

    onScopesSelectOpen() {
        if (this.isRecentScopesEnabled) {
            let scopeIdsArray = this.scopeOptions.map((o) => o['scope-id']);
            this.tabsAndScopesSelectorService.getItemsFromLocalForage().then((scopesMap) => {
                this.tabsAndScopesSelectorService.recentScopesByTabMap = scopesMap;
                if (this.recentScopeOptions) {
                    this.tabsAndScopesSelectorService.recentScopesByTabMap[this.tab] = this.recentScopeOptions.filter((scope) => {
                        return scopeIdsArray.indexOf(scope) > -1
                    });
                }
                let scopeSelected = document.querySelector('#scopes-select md-option[selected="selected"]');
                if (scopeSelected) {
                    let selectedScopeId = scopeSelected.getAttribute('value');
                    if (this.recentScopeOptions && this.recentScopeOptions.indexOf(selectedScopeId) > -1) {
                        this.$timeout(() => {
                            let recent = document.querySelector('#recent-scopes-select md-option[value="recentScope_' + selectedScopeId + '"]');
                            if (recent) {
                                this.$timeout(() => {
                                    recent.focus();
                                }, 100);
                            }
                        }, 100);
                    }
                }
            });
            let scopeCodesArray = scopeIdsArray.map((o) => 'scopes.option.' + o);
            this.$translate(scopeCodesArray).then((trans) => {
                let tmpObj = {};
                Object.keys(trans).forEach((e) => tmpObj[e.replace('scopes.option.', '')] = trans[e]);
                this.scopesTranslated = tmpObj;
            });
        }
    }

    onTabChange() {
        this.scope = this.scopeOptions[0]['scope-id'];
        this.tabsAndScopesSelectorService.updateIsRemoteTab(this.tab);
        this.updateFindInDbEvent.emit(this.tab);
        this.changeTabEvent.emit();
    }

    showScopesSelect() {
        return this.scopeOptions.length > 1;
    }

    showTabsSelect() {
        return this.tabOptions.length > 1;
    }

    private updateScopes() {
        if (this.configurationUtil.isSuprima()) {
            return;
        }
        this.tabsAndScopesSelectorService.updateScopes().then(res => {
            updateSearchScopesMap(res.data);
            this.searchScopesMap = getSearchScopesMap();
        });
    }

    public scopesInstructions() {
        this.isOpen = !this.isOpen;
    }
    
    // Switching to another tab / scope will clear 'pcAvailability' parameter from URL 
    // Only within the same scope once we clicked it remains for the next searches within this scope
    // Note 'pcAvailability' value is not matter
    public clearPcAvailability(){
        let pcAvailability = this.$stateParams['pcAvailability'];
        if(pcAvailability){
            this.changeUrl(pcAvailability, 'pcAvailability');
        }
    }
    public clearsearchInFulltext(){
        let searchInFulltext = this.$stateParams['searchInFulltext'];
        if(searchInFulltext){
            this.changeUrl(searchInFulltext, 'searchInFulltext');
        }
    }
    
    @preventStateReload
    private changeUrl(mode, valueToEncode: string){
        let newUrl = this.$location.url();
        newUrl = newUrl.replace("&"+ valueToEncode +"=" + encodeURIComponent(mode),"");
        this.$location.url(newUrl);
    }

    scopeListener() {
        this.scope = this.scope.replace('recentScope_', '');
    }

    public isBrowserEdge() {
        return this.isEdge;
    }

    public isBrowserIE() {
        return isBrowserIE();
    }

    public isPersonState() {
        return this.$state.current.name === STATE_NAMES.PERSON_ENTITY_PAGE;
    }

}

@Pipe({
    name: 'recentScopesFilter'
})
export class RecentScopesFilterPipe implements PipeTransform {

    transform(items: any[], translatedItems: any[], searchText: string, recentScopesArray: any[] = []): any {
        if (!searchText || !items) return items;
        return items.filter((o) => {
            let scopeid = o['scope-id'] || o;
            return ((translatedItems[scopeid] && translatedItems[scopeid].toLowerCase().indexOf(searchText.toLowerCase()) > -1)) &&
                (!recentScopesArray || recentScopesArray.indexOf(scopeid) < 0)
        });
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchBar/tabsAndScopesSelector/tabsAndScopesSelector.directive.ts